module.exports = __webpack_public_path__ + "static/media/anonymous-proxy.6284b6b2.png";